// The PrivateRoute component is a wrapper for protecting routes that require user authentication.
// It ensures that only logged-in users can access the routes it wraps.
//
// Functionality:
// 1. Uses the useAuthStatus hook to check if the user is logged in and whether the authentication status is still being determined.
// 2. If the authentication status is being checked, it displays a loading spinner (Spinner component).
// 3. If the user is logged in, it renders the child components of the route using the Outlet component.
// 4. If the user is not logged in, it redirects them to the login page using the Navigate component.
// 5. Integrates the useAutoLogout hook to handle automatic logout when the user's session expires.

import { Navigate, Outlet } from "react-router-dom"
import { useAuthStatus } from "../hooks/useAuthStatus"
import Spinner from "./Spinner"
import useAutoLogout from '../hooks/useAutoLogout';
import InactivityWarningModal from './InactivityWarningModal';

const PrivateRoute = () => {
    const { loggedIn, checkingStatus } = useAuthStatus();
    useAutoLogout();

    if (checkingStatus) {
        return <Spinner />;
    }

    return loggedIn ? (
        <>
            <Outlet />
            <InactivityWarningModal />
        </>
    ) : (
        <Navigate to='/login' />
    );
};

export default PrivateRoute

